import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function VolumeMaxIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g fill={color}>
        <path d="m18.5631 5.21196c1.7372 1.73725 2.8119 4.13712 2.8119 6.78804 0 2.651-1.0747 5.0509-2.8119 6.7881l-.9545-.9545c1.493-1.4929 2.4164-3.5554 2.4164-5.8336 0-2.27813-.9234-4.3406-2.4164-5.83355z" />
        <path d="m16.4309 7.0436c1.3752 1.20954 2.2441 2.981 2.2441 4.9564 0 1.9753-.8691 3.7464-2.2441 4.9559l-.9569-.9568c1.1319-.963 1.851-2.3965 1.851-3.9991s-.719-3.03659-1.851-3.99957z" />
        <path d="m14.2488 8.92563c1.0352.63228 1.7262 1.77267 1.7262 3.07437s-.6911 2.4416-1.7262 3.0739l-1.0002-1.0002c.8087-.3411 1.3764-1.1409 1.3764-2.0737s-.5676-1.7331-1.3764-2.07418z" />
        <path d="m6.225 15.15h-3c-.33137 0-.6-.2682-.6-.5996v-5.10076c0-.33137.26863-.5996.6-.5996h3s1.81682-1.09348 3-2.25c.56796-.55515 1.2958-1.42546 1.8923-2.17129.3607-.45096 1.1077-.19971 1.1077.37774v14.39531c0 .5766-.7444.8278-1.1048.3776-.6022-.7521-1.33639-1.631-1.8952-2.1794-1.20262-1.1801-3-2.25-3-2.25z" />
      </g>
    </SVGWrapper>
  );
}
export default VolumeMaxIcon;
